import { number } from '@calendly/form/validation'
import { HtmlParser } from '@calendly/html-parser'
import { I18n } from '@calendly/i18n'

import { DecreaseQuantityInvoiceMessage } from './invoice_messages/decrease_quantity_invoice_message'
import { IncreaseQuantityInvoiceMessage } from './invoice_messages/increase_quantity_invoice_message'

const getQuantityValidationSchema = (invalidQuantityMessage) => (
  number()
    .typeError(invalidQuantityMessage)
    .integer(I18n.t('errors.billing.quantity.invalid_number_of_org_members'))
    .min(0, I18n.t('errors.billing.quantity.invalid_number_of_org_members'))
    .test('is-non-zero', invalidQuantityMessage, (v) => v !== 0)
)

const IncreaseQuantityModalStrategy = () => ({
  titleI18n: I18n.t('publisher.billing.action.add_seats'),
  inputActionI18n: I18n.t('publisher.billing.change_quantity.add'),
  upcomingInvoiceErrorI18n: I18n.t('publisher.billing.failure.upgrade_problem'),
  confirmButtonI18n: I18n.t('publisher.billing.action.add_seats'),
  reactivateI18n: I18n.t('publisher.billing.change_quantity.adding_will_reactivate'),
  displayProratedCharge: false,
  displayChangeCard: true,
  getDisplayAppendSalesTax: (_invoice) => false,
  InvoiceMessage: IncreaseQuantityInvoiceMessage,
  getExtraQuantity: (quantity) => quantity,
  getValidationSchema: (_minQuantity, _currentQuantity) => (
    getQuantityValidationSchema(I18n.t('errors.billing.quantity.users_to_add_missing'))
  )
})

const DecreaseQuantityModalStrategy = () => ({
  titleI18n: I18n.t('publisher.billing.action.remove_seats'),
  inputActionI18n: I18n.t('publisher.billing.change_quantity.remove'),
  upcomingInvoiceErrorI18n: I18n.t('publisher.billing.failure.update_problem'),
  confirmButtonI18n: I18n.t('publisher.billing.action.remove_seats'),
  displayProratedCharge: false,
  displayChangeCard: false,
  getDisplayAppendSalesTax: (_invoice) => false,
  getExtraQuantity: (quantity) => -quantity,
  getValidationSchema: (minQuantity, currentQuantity) => (
    getQuantityValidationSchema(I18n.t('errors.billing.quantity.users_to_remove_missing'))
      .test({
        name: 'max',
        message: I18n.t('errors.billing.quantity.new_quantity_less_than_one'),
        test: (value) => value < currentQuantity
      })
      .test({
        name: 'max',
        message: ({ value }) => I18n.t('errors.billing.quantity.new_quantity_less_than_min_value', { count: currentQuantity - value }),
        test: (value) => value <= currentQuantity - minQuantity
      })
  ),
  InvoiceMessage: DecreaseQuantityInvoiceMessage
})

// i18n-tasks-use t('publisher.billing.change_plan.invoice_message.upgrade_tier.month_html')
// i18n-tasks-use t('publisher.billing.change_plan.invoice_message.upgrade_tier.year_html')
const UpgradeTierModalStrategy = () => ({
  billingAction: 'upgrade_tier',
  displayProratedCharge: true,
  upcomingInvoiceErrorI18n: I18n.t('publisher.billing.failure.upgrade_problem'),
  getDisplayAppendSalesTax: (invoice) => invoice.tax_applicable && invoice.next_charge_sales_tax_cents > 0,
  InvoiceMessage: ({ invoice }) => (
    HtmlParser(
      I18n.t(`${invoice.new_period_unit}_html`, {
        scope: 'publisher.billing.change_plan.invoice_message.upgrade_tier',
        amount: invoice.next_amount_due,
        date: invoice.next_payment_date,
        count: invoice.new_period_count
      })
    )
  )
})

const UpgradeFrequencyModalStrategy = () => ({
  billingAction: 'upgrade_frequency',
  displayProratedCharge: true,
  upcomingInvoiceErrorI18n: I18n.t('publisher.billing.failure.upgrade_problem'),
  getDisplayAppendSalesTax: (invoice) => invoice.tax_applicable && invoice.next_charge_sales_tax_cents > 0,
  InvoiceMessage: ({ invoice }) => (
    HtmlParser(
      I18n.t('publisher.billing.change_plan.invoice_message.upgrade_frequency_html', {
        amount: invoice.next_amount_due,
        date: invoice.next_payment_date
      })
    )
  )
})


export const ModalContentStrategyManager = () => ({
  getStrategy: (modalType) => {
    switch (modalType) {
      case 'IncreaseQuantity':
        return IncreaseQuantityModalStrategy()
      case 'DecreaseQuantity':
        return DecreaseQuantityModalStrategy()
      case 'UpgradeTier':
        return UpgradeTierModalStrategy()
      case 'UpgradeFrequency':
        return UpgradeFrequencyModalStrategy()
      default:
        return {}
    }
  }
})
